import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useQueryParams } from 'raviger';
import { Col, Card, ListGroup, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDiamondExclamation,
  faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons';
import Select from 'react-select';
import Header from '../components/Header';
import Scrollbar from '../components/Scrollbars';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const customStyles = {
  // For the select it self, not the options of the select
  control: (styles, { isDisabled}) => {
    return {
      ...styles,
      color: '#FFF',
      cursor: isDisabled ? 'not-allowed' : 'default',
      backgroundColor: isDisabled ? '#DFDDDD' : 'white',
      // height: 35,
      // minHeight: 35
    }
  },
  option: provided => ({
    ...provided,
    color: 'black'
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#595959' : 'black'
  }),
  menu: provided  => ({ ...provided, zIndex: 9999 })
};

function Vet({ incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({vet_requests:[], treatments:[], diagnostics:[], procedures:[], isFetching: true});
  const [reportData, setReportData] = useState([]);
  const [shelterOptions, setShelterOptions] = useState([]);
  const [selectedShelter, setSelectedShelter] = useState('all');
  const [animalData, setAnimalData] = useState({});
  const [activeOrders, setActiveOrders] = useState('vet_requests');

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchData = async () => {
      // Fetch Shelter data.
      await axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization + '&training=' + state.incident.training + '&medical=true', {
        cancelToken: source.token,
      })
      .then(async (shelterResponse) => {
        if (!unmounted) {
          let animal_data = {}
          const [vetResponse, treatmentResponse, diagnosticResponse, procedureResponse] = await Promise.all([
            axios.get('/vet/api/vetrequest/?incident=' + state.incident.id + '&today=true'),
            axios.get('/vet/api/treatmentplan/?incident=' + state.incident.id + '&today=true'),
            axios.get('/vet/api/diagnosticresults/?incident=' + state.incident.id + '&today=true'),
            axios.get('/vet/api/procedureresults/?incident=' + state.incident.id + '&today=true')
          ]);

          let vet_request_count = {'avian':0, 'cat':0, 'dog':0, 'camelid':0, 'small_mammals':0, 'reptile/amphibian':0, 'equine':0, 'ruminant':0, 'swine':0, 'other':0};
          vetResponse.data.results.forEach(vet_request => {
            if (Object.keys(animal_data).includes(String(vet_request.animal_object.id))) {
              animal_data[vet_request.animal_object.id]['vet_request'] = animal_data[vet_request.animal_object.id]['vet_request'] + 1;
            }
            else {
              animal_data[vet_request.animal_object.id] = vet_request.animal_object;
              animal_data[vet_request.animal_object.id]['vet_request'] = 1;
            }
            vet_request_count[vet_request.animal_object.category] += 1;
          })
          let treatment_count = {'avian':0, 'cat':0, 'dog':0, 'camelid':0, 'small_mammals':0, 'reptile/amphibian':0, 'equine':0, 'ruminant':0, 'swine':0, 'other':0};
          let track_plans = [];
          treatmentResponse.data.forEach(treatment => {
            if (!track_plans.includes(treatment.id)) {
              if (Object.keys(animal_data).includes(String(treatment.animal_object.id))){
                animal_data[treatment.animal_object.id]['treatment'] = (animal_data[treatment.animal_object.id]['treatment'] ? animal_data[treatment.animal_object.id]['treatment'] : 0) + 1;
              }
              else {
                animal_data[treatment.animal_object.id] = treatment.animal_object;
                animal_data[treatment.animal_object.id]['treatment'] = 1;
              }
              treatment_count[treatment.animal_object.category] += 1;
              track_plans.push(treatment.id)
            }
          });
          let diagnostic_count = {'avian':0, 'cat':0, 'dog':0, 'camelid':0, 'small_mammals':0, 'reptile/amphibian':0, 'equine':0, 'ruminant':0, 'swine':0, 'other':0};
          diagnosticResponse.data.results.forEach(diagnostic => {
            if (Object.keys(animal_data).includes(String(diagnostic.animal_object.id))){
              animal_data[diagnostic.animal_object.id]['diagnostic'] = (animal_data[diagnostic.animal_object.id]['diagnostic'] ? animal_data[diagnostic.animal_object.id]['diagnostic'] : 0) + 1;
            }
            else {
              animal_data[diagnostic.animal_object.id] = diagnostic.animal_object;
              animal_data[diagnostic.animal_object.id]['diagnostic'] = 1;
            }
            diagnostic_count[diagnostic.animal_object.category] += 1;
          });
          let procedure_count = {'avian':0, 'cat':0, 'dog':0, 'camelid':0, 'small_mammals':0, 'reptile/amphibian':0, 'equine':0, 'ruminant':0, 'swine':0, 'other':0};
          procedureResponse.data.results.forEach(procedure => {
            if (Object.keys(animal_data).includes(String(procedure.animal_object.id))){
              animal_data[procedure.animal_object.id]['procedure'] = (animal_data[procedure.animal_object.id]['procedure'] ? animal_data[procedure.animal_object.id]['procedure'] : 0) + 1;
            }
            else {
              animal_data[procedure.animal_object.id] = procedure.animal_object;
              animal_data[procedure.animal_object.id]['procedure'] = 1;
            }
            procedure_count[procedure.animal_object.category] += 1;
          });
          let report_data = Object.keys(vet_request_count).filter(key => vet_request_count[key] + treatment_count[key] + diagnostic_count[key] + procedure_count[key] > 0).map(key => ({'species':key, 'vet_requests':vet_request_count[key], 'treatments':treatment_count[key], 'diagnostics':diagnostic_count[key], 'procedures':procedure_count[key], 'total':vet_request_count[key] + treatment_count[key] + diagnostic_count[key] + procedure_count[key]}));
          let total = {'species':'total', 'vet_requests':report_data.reduce((a,v) => a = a + v.vet_requests, 0), 'treatments':report_data.reduce((a,v) => a = a + v.treatments, 0), 'diagnostics':report_data.reduce((a,v) => a = a + v.diagnostics, 0), 'procedures':report_data.reduce((a,v) => a = a + v.procedures, 0), 'total':report_data.reduce((a,v) => a = a + v.vet_requests, 0) + report_data.reduce((a,v) => a = a + v.treatments, 0) + report_data.reduce((a,v) => a = a + v.diagnostics, 0) + report_data.reduce((a,v) => a = a + v.procedures, 0)}
          report_data.push(total)
          setReportData(report_data);
          setData({vet_requests:vetResponse.data.results, treatments:treatmentResponse.data, diagnostics:diagnosticResponse.data.results, procedures:procedureResponse.data.results, isFetching: false});
          setAnimalData(animal_data);
          let shelter_options = [{value:'all', label:'All Animals'}];
          shelterResponse.data.forEach(shelter => {
            shelter_options.push({value:shelter.id, label:shelter.name});
          })
          shelter_options.push({value:'field', label:'Field Animals'});
          setShelterOptions(shelter_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };

    fetchData();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [incident, organization]);

  const vet_columns = [
    {
      name: 'Species',
      selector: row => row.species ? row.species[0].toUpperCase() + row.species.slice(1) :  row.species,
    },
    {
      name: 'Vet Requests',
      selector: row => row.vet_requests,
    },
    {
      name: 'Treatments',
      selector: row => row.treatments,
    },
    {
      name: 'Diagnostics',
      selector: row => row.diagnostics,
    },
    {
      name: 'Procedures',
      selector: row => row.procedures,
    },
  ];

  return (
    <>
    <Header>Veterinary Medicine</Header>
    <DataTable
      columns={vet_columns}
      data={reportData}
      title={'Daily Veterinary Tasks'}
      striped
      className="vetTable"
      noDataComponent={!data.isFetching ? <div style={{padding:"24px"}}>There are currently no tasks for today</div> : <div style={{padding:"24px"}}>Fetching daily veterinary task data...</div>}
    />
    <p className="phr" />
    <div className="row mb-2">
      <div className="col-12 d-flex">
        <Card className="mb-2 border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginBottom:""}}>
            <Card.Title style={{marginTop:"-2px", marginBottom:"-10px"}}>
            <h4>
              <Row className="d-flex gx-2">
                <Col xs={6}>
                  <label className="mb-2">Location</label>
                  <Select
                    id="status"
                    type="text"
                    name="status"
                    // className="mb-3"
                    options={shelterOptions}
                    styles={customStyles}
                    defaultValue={{value:'all', label:'All Animals'}}
                    onChange={(instance) => {
                      setSelectedShelter(instance === null ? '' : instance.value);
                    }}
                  />
                </Col>
              </Row>
            </h4>
            </Card.Title>
          </Card.Body>
        </Card>
      </div>
    </div>
    <div className="row mb-2">
      <div className="col-12 d-flex">
        <Card className="mb-2 border rounded" style={{width:"100%", height:"385px"}}>
          <Card.Body style={{marginBottom:""}}>
            <Card.Title style={{marginTop:"-2px", marginBottom:"20px"}}>
              <h4 className="mb-0">
                <Row className="ms-0">
                  <ListGroup horizontal style={{marginBottom:"-20px"}}>
                    <ListGroup.Item active={"vet_requests" === activeOrders} className="text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => setActiveOrders("vet_requests")}>
                      <div style={{marginTop:"-3px", marginLeft:"-1px", paddingLeft:"10px", paddingRight:"10px"}}>
                        Vet Requests ({data.vet_requests.filter(vr => selectedShelter === 'field' ? vr.animal_object.shelter === null : selectedShelter !== 'all' ? vr.animal_object.shelter === selectedShelter : vr).length})
                      </div>
                      {/* selectedShelter === 'field' ? animalData[animal_id].shelter === null : selectedShelter !== 'all' ? animalData[animal_id].shelter === selectedShelter : animal_id */}
                    </ListGroup.Item>
                    <ListGroup.Item active={"treatments" === activeOrders} className="text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => setActiveOrders("treatments")}>
                      <div style={{marginTop:"-3px", marginLeft:"-1px", paddingLeft:"10px", paddingRight:"10px"}}>
                        Treatments ({data.treatments.filter(treatment => selectedShelter === 'field' ? treatment.animal_object.shelter === null : selectedShelter !== 'all' ? treatment.animal_object.shelter === selectedShelter : treatment).length})
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item active={"diagnostics" === activeOrders} className="text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => setActiveOrders("diagnostics")}>
                      <div style={{marginTop:"-3px", marginLeft:"-1px", paddingLeft:"10px", paddingRight:"10px"}}>
                        Diagnostics ({data.diagnostics.filter(diagnostic => selectedShelter === 'field' ? diagnostic.animal_object.shelter === null : selectedShelter !== 'all' ? diagnostic.animal_object.shelter === selectedShelter : diagnostic).length})
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item active={"procedures" === activeOrders} className="text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => setActiveOrders("procedures")}>
                      <div style={{marginTop:"-3px", marginLeft:"-1px", paddingLeft:"10px", paddingRight:"10px"}}>
                        Procedures ({data.procedures.filter(procedure => selectedShelter === 'field' ? procedure.animal_object.shelter === null : selectedShelter !== 'all' ? procedure.animal_object.shelter === selectedShelter : procedure).length})
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Row>
              </h4>
            </Card.Title>
            {/* <Card.Title style={{marginTop:"-2px", marginBottom:"17px"}}>
              <h4 className="mb-0">
                Animals Requiring Treatment
              </h4>
            </Card.Title> */}
            <p className="phr" />
            <Scrollbar no_shadow="true" style={{height:"264px", minHeight:"264px"}} renderView={props => <div {...props} style={{...props.style, overflowX:"hidden", marginBottom:"-10px"}}/>}  renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
            {Object.keys(animalData).filter(animal_id => activeOrders === 'vet_requests' ? animalData[animal_id].vet_request > 0 : animal_id)
            .filter(animal_id => activeOrders === 'treatments' ? animalData[animal_id].treatment > 0 : animal_id)
            .filter(animal_id => activeOrders === 'diagnostics' ? animalData[animal_id].diagnostic > 0 : animal_id)
            .filter(animal_id => activeOrders === 'procedures' ? animalData[animal_id].procedure > 0 : animal_id)
            .filter(animal_id => selectedShelter === 'field' ? animalData[animal_id].shelter === null : selectedShelter !== 'all' ? animalData[animal_id].shelter === selectedShelter : animal_id).map((animal_id) => (
              <Link href={"/" + organization + "/" + incident + "/vet/medrecord/" + animalData[animal_id].medical_record} className="text-link" style={{color:"white", textDecoration: "none"}} key={animal_id}>
                <div className="mt-1 mb-1">
                  <div className="card-header border rounded ps-2" style={{fontSize:"20px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                    {activeOrders === 'vet_requests' && data.vet_requests.filter(vr => (Number(vr.animal_object.id) === Number(animal_id)) && vr.priority === 'urgent').length > 0 ?
                    <OverlayTrigger
                      key={"urgent"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-urgent`}>
                          This animal has been marked with an Urgent (Red) priority.
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faCircle} className="me-1 fa-move-up" size="sm" style={{color:"white"}} transform="shrink-4" inverse />
                        <FontAwesomeIcon icon={faDiamondExclamation} className="me-1 fa-move-up" style={{color:"#ff4c4c"}} inverse />
                      </span>
                    </OverlayTrigger> : ""}
                    {activeOrders === 'vet_requests' && data.vet_requests.filter(vr => (Number(vr.animal_object.id) === Number(animal_id)) && vr.caution === true).length > 0 ?
                    <OverlayTrigger
                      key={"caution"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-caution`}>
                          Use caution when handling this animal.
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers">
                        <FontAwesomeIcon icon={faCircle} className="me-1 fa-move-down" size="sm" style={{color:"white"}} transform="left-1 shrink-6" inverse />
                        <FontAwesomeIcon icon={faTriangleExclamation} className="me-1" style={{color:"#f2c81f"}} inverse />
                      </span>
                    </OverlayTrigger> : ""}
                    A#{animalData[animal_id].id_for_incident} - {animalData[animal_id].animal_count === 1 ? <span>{animalData[animal_id].name || 'Unknown Name'} <span style={{textTransform:'capitalize'}}>({animalData[animal_id].species_string}) -&nbsp;</span></span> : <span>{animalData[animal_id].animal_count} <span style={{textTransform:"capitalize"}}>({animalData[animal_id].species_string}) -&nbsp;</span></span>}
                    {activeOrders === 'vet_requests' && animalData[animal_id].vet_request ? <span style={{textTransform:'capitalize'}}>{data.vet_requests.filter(vr => Number(vr.animal_object.id) === Number(animal_id)).map(vr => vr.complaints_text).join(", ")}</span> : ""}
                    {activeOrders === 'treatments' && animalData[animal_id].treatment ? <span>{animalData[animal_id].treatment} Treatment{animalData[animal_id].treatment > 1 ? "s" : ""} Pending</span> : ""}
                    {activeOrders === 'diagnostics' && animalData[animal_id].diagnostic ? <span>{animalData[animal_id].diagnostic} Diagnostic{animalData[animal_id].diagnostic > 1 ? "s" : ""} Pending</span> : ""}
                    {activeOrders === 'procedures' && animalData[animal_id].procedure ? <span>{animalData[animal_id].procedure} Procedure{animalData[animal_id].procedure > 1 ? "s" : ""} Pending</span> : ""}
                  </div>
                </div>
                </Link>
            ))}
            {activeOrders === 'vet_requests' && data.vet_requests.filter(vr => selectedShelter === 'field' ? vr.animal_object.shelter === null : selectedShelter !== 'all' ? vr.animal_object.shelter === selectedShelter : vr).length === 0 ? <span>No animals require examination at this time.</span> : ""}
            {activeOrders === 'treatments' && data.treatments.filter(treatment => selectedShelter === 'field' ? treatment.animal_object.shelter === null : selectedShelter !== 'all' ? treatment.animal_object.shelter === selectedShelter : treatment).length === 0 ? <span>No animals require treatment at this time.</span> : ""}
            {activeOrders === 'diagnostics' && data.diagnostics.filter(diagnostic => selectedShelter === 'field' ? diagnostic.animal_object.shelter === null : selectedShelter !== 'all' ? diagnostic.animal_object.shelter === selectedShelter : diagnostic).length === 0 ? <span>No animals require diagnostics at this time.</span> : ""}
            {activeOrders === 'procedures' && data.procedures.filter(procedure => selectedShelter === 'field' ? procedure.animal_object.shelter === null : selectedShelter !== 'all' ? procedure.animal_object.shelter === selectedShelter : procedure).length === 0 ? <span>No animals require procedures at this time.</span> : ""}
            </Scrollbar>
          </Card.Body>
        </Card>
      </div>
    </div>
    </>
  )
}

export default Vet
